import { jsx } from "panel";
import { PropertyRenderType } from "common/util/format-property";
import { TooltipEl } from "common/components/tooltip";
import "./index.styl";
export var FormattedPropertyLayout = /* @__PURE__ */ ((FormattedPropertyLayout2) => {
  FormattedPropertyLayout2["Vertical"] = `vertical`;
  FormattedPropertyLayout2["Horizontal"] = `horizontal`;
  return FormattedPropertyLayout2;
})(FormattedPropertyLayout || {});
const SHOW_TOOLTIP_THRESHOLD = 40;
const MatchParts = ({
  value,
  isEmpty,
  matchParts,
  title
}) => matchParts ? /* @__PURE__ */ jsx(null, null, matchParts.map((part) => /* @__PURE__ */ jsx("span", {
  sel: ".property-match-part"
}, part))) : /* @__PURE__ */ jsx("div", {
  attrs: { title },
  class: { "not-set": isEmpty }
}, value, value.length > SHOW_TOOLTIP_THRESHOLD && /* @__PURE__ */ jsx(TooltipEl, {
  attrs: {
    text: value
  }
}));
export function FormattedPropertyMixin({
  property,
  layout,
  matchParts
}) {
  const {
    name: { formatted: propertyName },
    renderValue
  } = property;
  const { renderString, isEmpty, type, title, href } = renderValue;
  const matchName = matchParts == null ? void 0 : matchParts.name;
  const matchValue = matchParts == null ? void 0 : matchParts.value;
  return /* @__PURE__ */ jsx("div", {
    sel: ".property-wrapper",
    class: {
      [layout]: true
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".property-name"
  }, /* @__PURE__ */ jsx(MatchParts, {
    isEmpty,
    value: propertyName,
    matchParts: matchName
  })), /* @__PURE__ */ jsx("div", {
    sel: ".property-value"
  }, type === PropertyRenderType.String ? /* @__PURE__ */ jsx(MatchParts, {
    isEmpty,
    value: renderString,
    matchParts: matchValue,
    title
  }) : /* @__PURE__ */ jsx("a", {
    attrs: { href, title, target: type === PropertyRenderType.Link ? `_blank` : void 0 },
    on: { click: (ev) => ev.stopPropagation() }
  }, /* @__PURE__ */ jsx(MatchParts, {
    isEmpty,
    value: renderString,
    matchParts: matchValue
  }))));
}
